// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiDocumentsPortal } from '../../../redux/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '../../../interfaces/interfaces';
import {
  ApproverTasksListParams,
  ApproverTasksListResponse,
} from '../interfaces/interfaces';

export const approverTasksList = apiDocumentsPortal.injectEndpoints({
  endpoints: builder => ({
    getApproverTasksList: builder.query({
      query: ({ country, task_type, status }: ApproverTasksListParams) => {
        return `/pricing_tasks?country=${country}&task_type=${task_type}&status=${status}`;
      },
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'getApproverTasksList',
        };
        return modelError;
      },
      transformResponse: (response: ApproverTasksListResponse) => {
        return response.results;
      },
      providesTags: ['ApproverTasks'],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetApproverTasksListQuery } = approverTasksList;
